import * as HLF from "html-living-framework";
import {HoverableButton, TextureButton} from "../core/Button";
import {Callback, Mix} from "../core/Reflection";
import {TransformBackup} from "../core/TransformBackup";
import {TrashType} from "../data/TrashType";
import { OutlineFilter } from "../filters/OutlineFilter";
import { PulsatingButton } from "./Button";

export abstract class TrashItem extends Mix(TextureButton, HoverableButton(1.1), PulsatingButton, TransformBackup) {

    public abstract pickedUp: boolean;
    public readonly trashType: TrashType;
    public voiceoverA: string;
    public voiceoverB: string;
    public voiceoverC: string;
    protected outlineFilter = new OutlineFilter(5, 0xffff00);

    constructor(trashType: TrashType, texture: string, voiceoverA: string, voiceoverB: string, voiceoverC: string) {
        super(texture);
        this.name = texture.replace(/\.png$/, "");
        this.trashType = trashType;
        this.voiceoverA = voiceoverA;
        this.voiceoverB = voiceoverB;
        this.voiceoverC = voiceoverC;
        this.outlineFilter.enabled = false;
        this.visuals.filters = [this.outlineFilter];
    }

    public Highlight() {
        this.outlineFilter.enabled = true;
        this.pulse();
    }

    public UnHighlight() {
        this.outlineFilter.enabled = false;
        this.stopPulse();
    }
}
